module.exports = __webpack_public_path__ + "img/hefa.cb745f80.png";